export default __webpack_public_path__ + "static/media/about-testing.2ef8d7e7.png";